'use strict';

var React = require('react');

var SvgButtonCornerSquareMajor = function SvgButtonCornerSquareMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v2.79h-17.21v17.21h-2.79v-20z"
  }));
};

exports.SvgButtonCornerSquareMajor = SvgButtonCornerSquareMajor;
